import Vue  from "vue";
import VueRouter from "vue-router";
import Home  from "../components/Home";

import Embedded from "../components/Embedded"
import MetalCons  from "../components/MetalCons";
import Decorative  from "../components/Decorative";
import Street  from "../components/Street";
import Pointers  from "../components/Pointers";

import Playgrounds  from "../components/Playgrounds";
import Parking  from "../components/Parking";
import Metalstaircase  from "../components/Metalstaircase";
import Equipment from "../components/Equipment";
import Metaldecorative  from "../components/Metaldecorative";
import Gazebos  from "../components/Gazebos";
import Fences  from "../components/Fences";
import Bus  from "../components/Bus";
import Benches  from "../components/Benches";

import Balcony  from "../components/Balcony";
import Awnings  from "../components/Awnings";
import about  from "../components/about";
import contact  from "../components/contact";
import news  from "../components/news";
import partner  from "../components/partner";
import production  from "../components/production";
import project  from "../components/project";
import newspage  from "../components/newspage";


Vue.use(VueRouter);

const routes = [
  {
    path:"/",
    name:"Home",
    component:Home
   
  },
    {
      path:"/home",
      component:Home
     
    },
    {
      path:"/metalcons",
      component:MetalCons
    },
    {
      path:"/newspage",
      component:newspage
    },
    {
      path:"/embedded",
      component:Embedded
    },
    {
      path:"/Street",
      component:Street
    },
    {
      path:"/Pointers",
      component:Pointers
    },
    {
      path:"/project",
      component:project
    },
    {
      path:"/contact",
      component:contact
    },
    {
      path:"/news",
      component:news
    },
    {
      path:"/partner",
      component:partner
    },
    {
      path:"/about",
      component:about
    },
    {
      path:"/Playgrounds",
      component:Playgrounds
    },
    {
      path:"/Equipment",
      component:Equipment
    },
    {
      path:"/production",
      component:production
    },
    {
      path:"/Parking",
      component:Parking
    },
    {
      path:"/Metalstaircase",
      component:Metalstaircase
    },
    {
      path:"/Metaldecorative",
      component:Metaldecorative
    },
    {
      path:"/Gazebos",
      component:Gazebos
    },
    {
      path:"/Fences",
      component:Fences
    },
    {
      path:"/Decorative",
      component:Decorative
    },
    {
      path:"/Bus",
      component:Bus
    },
    {
      path:"/Benches",
      component:Benches
    },
    {
      path:"/Balcony",
      component:Balcony
    },
    {
      path:"/Awnings",
      component:Awnings
    }
];
const router =new VueRouter({
    routes
});

export default router;